<div class="courses-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell">
    <div class="custom-container">
      <!-- HERO -->
      <section class="hero-section">
        <div class="hero-bg-shape hero-bg-shape-one"></div>
        <div class="hero-bg-shape hero-bg-shape-two"></div>

        <div class="hero-content">
          <div class="hero-left">
            <span class="hero-badge">Admissions Open 2026</span>
            <h1>Courses Offered</h1>
            <p>
              Explore our undergraduate, postgraduate, and doctoral programmes
              designed to support academic excellence, technical knowledge,
              research, and career growth.
            </p>
          </div>

          <div class="hero-right">
            <div class="hero-stat-card">
              <span class="hero-stat-number">{{ ugCourses.length }}</span>
              <span class="hero-stat-label">UG Programmes</span>
            </div>

            <div class="hero-stat-card">
              <span class="hero-stat-number">{{ pgCourses.length }}</span>
              <span class="hero-stat-label">PG Programmes</span>
            </div>

            <div class="hero-stat-card">
              <span class="hero-stat-number">{{ phdCourses.length }}</span>
              <span class="hero-stat-label">Ph.D Programmes</span>
            </div>
          </div>
        </div>
      </section>

      <!-- CONTENT -->
      <div class="page-content">
        <div class="row g-4">
          <!-- LEFT -->
          <div class="col-lg-8 col-md-12">
            <!-- UG -->
            <section class="content-card">
              <div class="section-header">
                <div>
                  <span class="section-tag">Under Graduate</span>
                  <h2>Under Graduate Courses</h2>
                  <p>Choose from our career-oriented undergraduate programmes.</p>
                </div>

                <span class="section-count">{{ ugCourses.length }} Courses</span>
              </div>

              <div class="course-bucket-grid">
                <article
                  class="course-bucket"
                  *ngFor="let course of ugCourses; trackBy: trackById"
                >
                  <div class="bucket-top">
                    <span class="bucket-serial">{{ course.id | number:'2.0' }}</span>
                    <span class="bucket-badge">{{ course.degree }}</span>
                  </div>

                  <div class="bucket-body">
                    <ng-container *ngIf="!isDisabledRoute(course.route); else ugPlainName">
                      <a [routerLink]="course.route" class="course-link">
                        {{ course.name }}
                      </a>
                    </ng-container>

                    <ng-template #ugPlainName>
                      <span class="course-link disabled-link">{{ course.name }}</span>
                    </ng-template>

                    <div class="bucket-meta">
                      <span>{{ course.duration }}</span>
                    </div>
                  </div>
                </article>
              </div>
            </section>

            <!-- PG -->
            <section class="content-card">
              <div class="section-header">
                <div>
                  <span class="section-tag">Post Graduate</span>
                  <h2>Post Graduate Courses</h2>
                  <p>Advanced programmes for specialization and higher learning.</p>
                </div>

                <span class="section-count">{{ pgCourses.length }} Courses</span>
              </div>

              <div class="course-bucket-grid">
                <article
                  class="course-bucket"
                  *ngFor="let course of pgCourses; trackBy: trackById"
                >
                  <div class="bucket-top">
                    <span class="bucket-serial">{{ course.id | number:'2.0' }}</span>
                    <span class="bucket-badge">{{ course.degree }}</span>
                  </div>

                  <div class="bucket-body">
                    <ng-container *ngIf="!isDisabledRoute(course.route); else pgPlainName">
                      <a [routerLink]="course.route" class="course-link">
                        {{ course.name }}
                      </a>
                    </ng-container>

                    <ng-template #pgPlainName>
                      <span class="course-link disabled-link">{{ course.name }}</span>
                    </ng-template>

                    <div class="bucket-meta">
                      <span>{{ course.duration }}</span>
                    </div>
                  </div>
                </article>
              </div>
            </section>

            <!-- Ph.D -->
            <section class="content-card">
              <div class="section-header">
                <div>
                  <span class="section-tag">Doctoral Programme</span>
                  <h2>Ph.D Courses</h2>
                  <p>
                    Research programme offered through our recognized research centre.
                  </p>
                </div>

                <span class="section-count">{{ phdCourses.length }} Course</span>
              </div>

        

              <div class="course-bucket-grid single-course-grid">
                <article
                  class="course-bucket"
                  *ngFor="let course of phdCourses; trackBy: trackById"
                >
                  <div class="bucket-top">
                    <span class="bucket-serial">{{ course.id | number:'2.0' }}</span>
                    <span class="bucket-badge">{{ course.degree }}</span>
                  </div>

                  <div class="bucket-body">
                    <ng-container *ngIf="!isDisabledRoute(course.route); else phdPlainName">
                      <a [routerLink]="course.route" class="course-link">
                        {{ course.name }}
                      </a>
                    </ng-container>

                    <ng-template #phdPlainName>
                      <span class="course-link disabled-link">{{ course.name }}</span>
                    </ng-template>

                    <div class="bucket-meta">
                      <span>{{ course.duration }}</span>
                    </div>
                  </div>
                </article>
              </div>
            </section>
          </div>

          <!-- RIGHT -->
          <div class="col-lg-4 col-md-12">
            <aside class="sidebar">
              <!-- FLYER -->
              <section class="sidebar-card flyer-card-wrap">
                <div class="card-header">
                  <h3>Admission Flyer</h3>
                </div>

                <button
                  type="button"
                  class="flyer-card"
                  (click)="openBrochureModal()"
                  aria-label="Open admission flyer"
                >
                  <img [src]="brochureImage" alt="Admission Flyer" />
                  <div class="flyer-overlay">
                    <span>Click to View Full Flyer</span>
                  </div>
                </button>
              </section>

              <!-- CONTACT -->
              <section class="sidebar-card">
                <div class="card-header">
                  <h3>Call for Admission</h3>
                </div>

                <div class="contact-list">
                  <a
                    *ngFor="let phone of admissionPhones; trackBy: trackByValue"
                    class="contact-item"
                    [href]="'tel:' + phone"
                  >
                    {{ phone }}
                  </a>
                </div>
              </section>

              <!-- COORDINATORS -->
              <section class="sidebar-card">
                <div class="card-header">
                  <h3>Admission Co-ordinators</h3>
                </div>

                <div class="table-wrapper">
                  <table class="table coordinator-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let person of coordinators; trackBy: trackById">
                        <td>{{ person.id }}</td>
                        <td>{{ person.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>

              <!-- APPLY -->
              <section class="sidebar-card apply-card">
                <span class="apply-mini-tag">Apply Now</span>
                <h3>Start Your Journey With Us</h3>
                <p>
                  Submit your enquiry and connect with our admission team for
                  complete guidance and support.
                </p>

                <a class="apply-btn" routerLink="/inquiry">
                  Apply Now
                </a>
              </section>
            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FLYER MODAL -->
  <div
    class="flyer-modal-backdrop"
    *ngIf="showBrochureModal"
    (click)="closeBrochureModal()"
  >
    <div
      class="flyer-modal-dialog"
      (click)="$event.stopPropagation()"
      role="dialog"
      aria-modal="true"
      aria-label="Admission flyer preview"
    >
      <button
        type="button"
        class="flyer-close-btn"
        (click)="closeBrochureModal()"
        aria-label="Close flyer"
      >
        ×
      </button>

      <div class="flyer-modal-body">
        <img [src]="brochureImage" alt="Admission Flyer Full View" />
      </div>
    </div>
  </div>
</div>